import React, { useState } from "react";
import "./walletStyles.scss";
import "react-toggle/style.css";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";
import Step4 from "./components/Step4";
import { PaymentMethod, Values } from "./types";
import Step5 from "./components/step5";
import Step6 from "./components/Step6";
import { IPayPal, IPayoneer } from "./types";

export function getEmptyDetails(type: string): IPayoneer | IPayPal {
  if (type === "paypal") {
    return { email: "" };
  } else {
    return { payoneerId: "" };
  }
}


export const WalletSettings: React.FC = () => {
  const [currentStep, setCurrentStep] = React.useState<number>(1);

  const [selectedItem, setSelectedItem] = useState<PaymentMethod>({
    id: "",
    type: "",
    accountEnding: "",
    isPrimary: false,
    details: getEmptyDetails("")
  });

  const [values, updateValues] = useState<Values>({
    data: [],
    loading: false,
    error: "",
  });

  const steps: { [key: number]: JSX.Element } = {
    1: (
      <Step1
        setCurrentStep={setCurrentStep}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        values={values}
        updateValues={updateValues}
      />
    ),
    2: (
      <Step2
        setCurrentStep={setCurrentStep}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        values={values}
        updateValues={updateValues}
      />
    ),
    3: (
      <Step3
        setCurrentStep={setCurrentStep}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        values={values}
        updateValues={updateValues}
      />
    ),
    4: (
      <Step4
        setCurrentStep={setCurrentStep}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        values={values}
        updateValues={updateValues}
      />
    ),
    5: (
      <Step5
        setCurrentStep={setCurrentStep}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        values={values}
        updateValues={updateValues}
      />
    ),
    6: (
      <Step6
        setCurrentStep={setCurrentStep}
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        values={values}
        updateValues={updateValues}
      />
    ),
  };

  return <div className="walletContainer">{steps[currentStep]}</div>;
};
